
import { defineComponent, ref, watch, onMounted } from 'vue'
import { ColorPicker } from "vue3-colorpicker";
import { ColorInputWithoutInstance } from "tinycolor2";
import "vue3-colorpicker/style.css";

export default defineComponent({
    name: 'FormColorPicker',
    props: {
        color: String,
    },
    emits: ['updatePicker'],
    components: { ColorPicker },
    setup(props, { emit }) {
        const pureColor = ref<ColorInputWithoutInstance>("#2e2e2e");

        const onPickerUpdate = (val) => {
            emit('updatePicker', val)
        }

        watch(() => props.color, (val) => {
            pureColor.value = val
        });

        return {
            pureColor,
            onPickerUpdate
        };
    }
})
